import { useStaticQuery, graphql } from 'gatsby'

export const useMultiStepFormQuery = () => {
  const { wp } = useStaticQuery(graphql`
    query MultiStepFormQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            logo {
              sourceUrl
              mediaDetails {
                width
                height
              }
            }
            logoAltText
            phoneNumber
          }
        }
        acfOptionsMultiStepForm {
          multiStepForm {
            stepTitles {
              stepTitle
            }
            vanImage {
              sourceUrl
              mediaDetails {
                width
                height
              }
            }
            vanImageAltText
            residentialOrCommercial {
              option
            }
            issues {
              issue
              subIssues {
                subIssue
              }
            }
            moreInfo
            photoText
            maxUploadText
            appointmentText
            confirmationText
            formSubmittedText
          }
        }
      }
    }
  `)
  return { wp }
}
